import { Component, DEFAULT_CURRENCY_CODE, ElementRef, Inject, Injectable, LOCALE_ID, OnInit, ViewChild } from '@angular/core';
import { Assignment } from 'src/app/classes/assignment';
import { ShiftService } from 'src/app/services/shift.service';
import * as fa from '@fortawesome/free-solid-svg-icons';
import { AuthImgPipe } from 'src/app/pipes/auth-img.pipe';
import { FormArray, FormControl, FormGroup, FormRecord, Validators } from '@angular/forms';
import { Product } from 'src/app/classes/product';
import { SettingsService } from 'src/app/services/settings.service';
import { Customer } from 'src/app/classes/customer';
import { CustomerService } from 'src/app/services/customer.service';
import { DatePipe, getCurrencySymbol } from '@angular/common';
import { Employee } from 'src/app/classes/employee';
import { PaymentService } from 'src/app/services/payment.service';
import { Shift } from 'src/app/classes/shift';
import { Browser } from '@capacitor/browser';
import { Observable, Subscription, defaultIfEmpty, forkJoin } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerContact } from 'src/app/classes/customer-contact';
import { Organization } from 'src/app/classes/organization';
import { NgbDateAdapter, NgbDateNativeAdapter, NgbDateParserFormatter, NgbDateStruct, NgbDatepicker, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Holiday } from 'src/app/classes/holiday';
import { TncComponent } from '../common/tnc/tnc.component';
import { Capacitor } from '@capacitor/core';
import { CustomerContactDiscount } from 'src/app/classes/customer-contact-discount';
import discountTypes from 'src/app/constants/discount-types';
import { AiService } from 'src/app/services/ai.service';
import { LanguageSelectorComponent } from '../common/language-selector/language-selector.component';
import locales from 'src/app/constants/locales';
import { ApiService } from 'src/app/services/api.service';
import { PrivacyPolicyComponent } from '../common/privacy-policy/privacy-policy.component';
import { environment } from 'src/environments/environment';
import { Title } from '@angular/platform-browser';
import productUnits from 'src/app/constants/product-units';
import { ProductComponent } from '../public/order/services/product/product.component';

@Injectable()
export class CustomDateAdapter {
  fromModel(value: string): NgbDateStruct {
    if (!value)
      //@ts-ignore
      return null

    let parts = value.split('-');
    return { year: +parts[0], month: +parts[1], day: +parts[2] }
  }

  toModel(date: NgbDateStruct): string // from internal model -> your mode
  {
    //@ts-ignore
    return date ? date.year + "-" + ('0' + date.month).slice(-2)
      + "-" + ('0' + date.day).slice(-2) : null
  }
}

@Injectable()
export class CustomDateParserFormatter {
  parse(value: string): NgbDateStruct {
    if (!value)
      // @ts-ignore
      return null
    let parts = value.split('/');
    return { year: +parts[2], month: +parts[1], day: +parts[3] } as NgbDateStruct

  }
  format(date: NgbDateStruct): string {
    // @ts-ignore
    return date ? ('0' + date.day).slice(-2) + "/" + ('0' + date.month).slice(-2) + "/" + date.year : null
    //return date ? date.year + "/" + ('0' + date.month).slice(-2) + "/" + ('0' + date.day).slice(-2) : null
  }
}

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss'],
  providers: [
    AuthImgPipe,
    DatePipe,
    { provide: NgbDateAdapter, useClass: CustomDateAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }
  ]
})
export class CheckoutComponent implements OnInit {
  @ViewChild('date') date!: NgbDatepicker
  @ViewChild('pictureTag') pictureTag!: ElementRef


  assignment = new Assignment()
  environment = environment

  sending = false
  organization!: Organization
  assignments: Assignment[] = []
  holidays: Holiday[] = []
  customers: Customer[] = []
  user: CustomerContact = new CustomerContact()
  customer: Customer = new Customer()
  productsAll: Product[] = []
  employees: Employee[] = []
  checkoutShifts: { shifts: Shift[], total_invoicable: number } = { shifts: [], total_invoicable: 0 }
  checkoutShiftloaded = false
  subscription!: Subscription
  discountTypes = discountTypes
  copyrightYear = new Date().getFullYear()
  locales = locales
  orderProducts: any[] = []
  platform = Capacitor.getPlatform()
  productUnits = productUnits

  tomorrow = this.datePipe.transform(new Date().setDate(new Date().getDate() + 1), 'yyyy-MM-dd')
  currencyCode = getCurrencySymbol(this.defaultCurrencyCode, 'narrow')

  fa = fa
  Number = Number

  activeTab: string = ''
  price = 0
  paymentError = ''

  selectedAssignment: Assignment = new Assignment()

  minimumOrder = 0
  minDate!: NgbDateStruct
  discounts: CustomerContactDiscount[] = []
  pictures: any[] = []

  startTimes: string[] = []

  currentUser = new CustomerContact()

  shiftForm = new FormGroup({
    date: new FormControl<null | string>(null, [Validators.required]),
    start_times: new FormControl<null | string[]>(null),
    end_time: new FormControl<null | string>(null),
    assignment_id: new FormControl<null | number>(null, [Validators.required]),
    customer: new FormControl<null | Customer>(null),
    employee_id: new FormControl<null | number>(null),
    products: new FormControl<any>([]),
    notes: new FormControl('', { nonNullable: true }),
    repeat: new FormControl(''),
    payment: new FormControl<string | number | null>(null, [Validators.required]),
    tnc: new FormControl(false, [Validators.requiredTrue]),
    discount_id: new FormControl<null | number>(null),
    mobile_phone: new FormControl(''),
  })

  constructor(private settingsService: SettingsService,
    private customerService: CustomerService,
    private shiftService: ShiftService,
    private paymentService: PaymentService,
    private aiService: AiService,
    public authImg: AuthImgPipe,
    public datePipe: DatePipe,
    public router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private apiService: ApiService,
    private titleService: Title,
    @Inject(LOCALE_ID) public locale: string,
    @Inject(DEFAULT_CURRENCY_CODE) public defaultCurrencyCode: string
  ) { }

  ngOnInit() {
    window.scrollTo(0, 0)

    this.titleService.setTitle($localize`Checkout`)

    this.customerService.current().subscribe(user => {
      this.currentUser = user

      if (!user.mobile_phone) {
        this.shiftForm.addControl('mobile_phone', new FormControl('', [Validators.required]))
      }
    })

    if (!this.shiftForm.controls.notes.value) {
      this.aiService.summariseSalesAssistant(localStorage.getItem('sales_chat_id')).subscribe(result => {
        if (result.summary) {
          this.shiftForm.controls.notes.setValue(result.summary)
        }
      })
    }

    this.settingsService.organization().subscribe({
      next: (organization) => {
        this.organization = organization

        this.minimumOrder = organization.minimum_order

        const order = JSON.parse(localStorage.getItem('order')!)

        if (order && order.assignment_id) {
          this.settingsService.assignment(order.assignment_id).subscribe(assignment => {
            this.assignment = assignment

            if (assignment.minimum_order)
              this.minimumOrder = assignment.minimum_order
          })

          this.settingsService.assignmentProductsPublic(order.assignment_id).subscribe(products => {
            this.productsAll = products

            this.shiftForm.patchValue(order)

            this.updateOrderProducts()

            this.settingsService.discounts().subscribe(discounts => {
              this.discounts = discounts

              if (discounts.length) {
                this.shiftForm.controls.discount_id.setValue(this.discounts[0].id)
                this.shiftForm.controls.discount_id.updateValueAndValidity()
              }
              
              this.shiftService.checkout(this.shiftForm.value).subscribe({
                next: (shifts) => {
                  this.checkoutShifts = shifts
                  this.checkoutShiftloaded = true
                },
                error: (error) => {
                  console.error(error)
                  this.checkoutShiftloaded = false
                }
              })
              
            })
          })
        }

        else {
          this.router.navigate(['/'])
        }
      }, error: () => {
        this.router.navigate(['/'])
      }
    })

    this.customerService.current().subscribe(contact => {
      this.user = contact

      if (this.user.default_card_id) {
        this.shiftForm.controls.payment.setValue(this.user.default_card_id)
      }
      else {
        this.shiftForm.controls.payment.setValue('new_card')
      }
    })
  }

  updateDiscount() {
    if (this.shiftForm.controls.discount_id.value) {
      this.shiftForm.controls.repeat.setValue('')
    }

    this.shiftService.checkout(this.shiftForm.value).subscribe({
      next: (shifts) => {
        this.checkoutShifts = shifts
        this.checkoutShiftloaded = true
      },
      error: (error) => {
        console.error(error)
        this.checkoutShiftloaded = false
      }
    })
  }

  updateRepeat() {
    if (this.shiftForm.controls.repeat.value) {
      this.shiftForm.controls.discount_id.setValue(null)
    }
    else if (this.discounts.length) {
      this.shiftForm.controls.discount_id.setValue(this.discounts[0].id)
    }

    this.shiftService.checkout(this.shiftForm.value).subscribe({
      next: (shifts) => {
        this.checkoutShifts = shifts
        this.checkoutShiftloaded = true
      },
      error: (error) => {
        console.error(error)
        this.checkoutShiftloaded = false
      }
    })
  }

  validStartDate = (date: NgbDateStruct, current?: { year: number; month: number; }): boolean => {
    const d = new Date(Date.UTC(date.year, date.month - 1, date.day, 0, 0, 0, 0));
    const dateStr = d.toISOString().split('T')[0]

    if ((d.getDay() == 1 && !this.organization.customer_order_monday)
      || (d.getDay() == 2 && !this.organization.customer_order_tuesday)
      || (d.getDay() == 3 && !this.organization.customer_order_wednesday)
      || (d.getDay() == 4 && !this.organization.customer_order_thursday)
      || (d.getDay() == 5 && !this.organization.customer_order_friday)
      || (d.getDay() == 6 && !this.organization.customer_order_saturday)
      || (d.getDay() == 0 && !this.organization.customer_order_sunday)
    ) {
      return true
    }

    if (this.holidays.filter(holiday => holiday.date == dateStr).length > 0) {
      return true
    }

    return false
  }

  pictureRemove(index: number) {
    this.pictures.splice(index, 1)
  }

  pictureAdd(event: any) {
    const picture: any = {}

    if (event.target.files && event.target.files.length) {
      let i: number = 0;

      for (let file of event.target.files) {
        var reader = new FileReader();
        reader.readAsDataURL(file);

        picture.file = file

        reader.onload = (eventFile: any) => {
          picture.src = eventFile.target.result;
        }

        this.pictures.push(picture)
      }
    }
  }

  selectContent(event: any) {
    (event.target as HTMLInputElement).select()
  }



  tnc() {
    const modal = this.modalService.open(TncComponent, { size: 'lg', scrollable: true })

    modal.componentInstance.organization = this.organization

    modal.result.then((result) => {

      if (result == 'accept') {
        this.shiftForm.controls.tnc.setValue(true)
      }
    })
  }

  order() {
    if (!this.shiftForm.controls.payment.value) {
      alert($localize`You need to select a payment method.`)
      return
    }

    if (!this.shiftForm.controls.tnc.value) {
      alert($localize`You need to accept the terms and conditions.`)
      return
    }

    if (this.checkoutShifts.total_invoicable < this.minimumOrder) {
      alert($localize`Your order is below the minimum order amount.`)
      return
    }

    this.sending = true

    const platform = Capacitor.getPlatform()

    this.shiftService.order(this.shiftForm.value).subscribe({
      next: (orderedShifts) => {
        this.sending = false

        this.checkoutShifts = orderedShifts
        this.checkoutShiftloaded = true

        const pictureUploads: Observable<any>[] = []

        // Upload pictures
        for (let picture of this.pictures) {
          pictureUploads.push(this.shiftService.addFile(orderedShifts.shifts[0].id, picture))
        }

        forkJoin(pictureUploads).pipe(defaultIfEmpty(null)).subscribe(async (results) => {
          // DISABLED FOR NOW
          if (false && this.shiftForm.controls.payment.value == 'new_card') {
            if (!this.organization.payment_api) {
              if (platform != 'web') {
                await Browser.open({ url: 'https://www.tbcbank.ge/' })
              }

              else {
                location.href = 'https://www.tbcbank.ge/'
              }

              return
            }

            this.paymentService.newCard(this.organization.payment_api, {
              shifts: orderedShifts.shifts,
              locale: this.locale,
              platform: platform,
            }).subscribe({
              next: async (payment) => {

                if (platform != 'web') {
                  await Browser.open({ url: payment.redirect_url })

                  Browser.addListener('browserFinished', () => {
                    Browser.removeAllListeners()

                    localStorage.removeItem('order')

                    this.router.navigate(['/shifts', orderedShifts[0].id])
                  })

                  this.paymentService.wait(`${payment.id}`).subscribe(async (payment) => {
                    Browser.removeAllListeners()
                    await Browser.close()

                    localStorage.removeItem('order')

                    this.router.navigate(['/shifts', orderedShifts[0].id])
                  })
                }
                else {
                  localStorage.removeItem('order')
                  location.href = payment.redirect_url
                }
              },
              error: () => {

              }
            })
          }

          else {
            alert($localize`Order created successfully.`)
            localStorage.removeItem('order')

            this.router.navigate(['/shifts', orderedShifts[0].id])
          }
        })
      }, error: () => {
        this.sending = false
      }
    })
  }

  cancel() {
    if (confirm($localize`Are you sure?`)) {
      localStorage.removeItem('order')
      this.router.navigate(['/'])
    }
  }

  scrollToBottom() {
    setTimeout(() => { window.scrollTo(0, document.body.scrollHeight); }, 50)
  }

  languageSelector() {
    const modal = this.modalService.open(LanguageSelectorComponent, { centered: true, size: 'md' })
  }

  privacyPolicy() {
    const modal = this.modalService.open(PrivacyPolicyComponent, { centered: true, size: 'lg' })
  }

  schedule() {
    this.shiftForm.controls.employee_id.setValue(null)
    this.shiftForm.controls.start_times.setValue(null)

    localStorage.setItem('order', JSON.stringify(this.shiftForm.value))

    this.router.navigate(['/schedule'])
  }

  deleteProduct(index: number) {
    if (!confirm($localize`Are you sure you want to remove this item from your order?`)) {
      return
    }

    this.shiftForm.controls.products.value.splice(index, 1)

    if (this.shiftForm.controls.products.value.length == 0) {
      this.shiftForm.controls.assignment_id.setValue(null)
      alert($localize`Your order is empty.`)
      this.router.navigate(['/'])
    }

    else {
      this.shiftService.checkout(this.shiftForm.value).subscribe({
        next: (shifts) => {
          this.checkoutShifts = shifts.shifts
          this.checkoutShiftloaded = true
        },
        error: (error) => {
          console.error(error)
          this.checkoutShiftloaded = false
        }
      })
    }

    this.updateOrderProducts()
  }

  editProduct(index: number) {
    const modal = this.modalService.open(ProductComponent, { centered: true, fullscreen: 'lg' })

    modal.componentInstance.assignment = this.assignment
    modal.componentInstance.product = this.productsAll.find(p => p.id === this.orderProducts[index].product.id)
    modal.componentInstance.values = this.orderProducts[index]
    modal.componentInstance.noNext = true

    modal.result.then((result) => {
      if (result) {
        if (!this.shiftForm.controls.assignment_id.value) {
          this.shiftForm.controls.assignment_id.setValue(this.assignment.id)
        }
        else if (this.shiftForm.controls.assignment_id.value != this.assignment.id) {
          if (confirm($localize`You can order services from one category at a time. Are you sure you want to change the category?`)) {
            this.shiftForm.controls.assignment_id.setValue(this.assignment.id)
            this.shiftForm.controls.products.setValue([])
            this.updateOrderProducts()
          }
          else {
            return
          }
        }

        if (!this.shiftForm.controls.products.value) {
          this.shiftForm.controls.products.setValue([])
        }

        if (result.number < 1) {
          this.shiftForm.controls.products.value.splice(index, 1)
        }

        else {
          this.shiftForm.controls.products.value[index] = result
        }

        this.shiftService.checkout(this.shiftForm.value).subscribe({
          next: (shifts) => {
            this.checkoutShifts = shifts
            this.checkoutShiftloaded = true
          },
          error: (error) => {
            console.error(error)
            this.checkoutShiftloaded = false
          }
        })

        this.updateOrderProducts()
      }
    })
  }

  updateOrderProducts() {
    this.orderProducts = []

    if (!this.shiftForm.controls.products.value || !Array.isArray(this.shiftForm.controls.products.value)) {
      this.shiftForm.controls.products.setValue([])
    }

    for (let product of this.shiftForm.controls.products.value) {
      let productObject = this.productsAll.find(p => p.id == product.product_id)

      if (!productObject) {
        this.settingsService.assignmentProductsPublic(this.shiftForm.controls.assignment_id.value as number).subscribe(products => {
          productObject = products.find((p: any) => p.id == product.product_id)

          this.orderProducts.push({ ...product, product: productObject })
        })

        continue
      }

      this.orderProducts.push({ ...product, product: productObject })
    }

    localStorage.setItem('order', JSON.stringify(this.shiftForm.value))
  }
}
